// extracted by mini-css-extract-plugin
export default {"tableRow":"CategoriesTable_tableRow__Ay4al"};